(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-footer-localization')) {
    customElements.define('cc-footer-localization', class extends HTMLElement {
      connectedCallback() {
        this.onChange = event => {
          if (event.target.matches('select[name="language_code"], select[name="country_code"]')) {
            event.target.form?.requestSubmit();
          }
        };
        this.addEventListener('change', this.onChange);
      }
      disconnectedCallback() { this.removeEventListener('change', this.onChange); }
    });
  }

  if (!customElements.get('cc-footer-menus')) {
    customElements.define('cc-footer-menus', class extends HTMLElement {
      connectedCallback() {
        this.breakpoint = window.matchMedia('(min-width: 750px)');
        this.update = () => this.querySelectorAll('details').forEach(menu => { menu.open = this.breakpoint.matches; });
        this.update();
        this.breakpoint.addEventListener('change', this.update);
        this.selectBlock = event => { const menu = event.target.closest('details'); if (menu && this.contains(menu)) menu.open = true; };
        this.addEventListener('shopify:block:select', this.selectBlock);
      }
      disconnectedCallback() {
        this.breakpoint?.removeEventListener('change', this.update);
        this.removeEventListener('shopify:block:select', this.selectBlock);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-founder-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  let observer;
  let targets = [];
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reset = () => {
    if (observer) observer.disconnect();
    targets.forEach(element => {
      element.classList.remove('cc-story-reveal', 'cc-story-reveal--pending', 'cc-story-reveal--text');
      element.style.removeProperty('--cc-reveal-duration');
      element.style.removeProperty('--cc-reveal-distance');
    });
    targets = [];
  };
  const initialize = () => {
    reset();
    const control = document.querySelector('[data-cc-story-reveal]');
    if (!control || control.dataset.ccStoryReveal !== 'true' || motion.matches || !('IntersectionObserver' in window)) return;
    const page = control.closest('main');
    if (!page) return;
    const duration = Math.max(400, Math.min(3000, Number(control.dataset.ccRevealDuration) || 1800));
    const distance = Math.max(0, Math.min(80, Number(control.dataset.ccRevealDistance)));
    targets = Array.from(page.querySelectorAll('.cc-founder h1, .cc-founder h2, .cc-founder__text > *, .cc-founder__link, .cc-founder__figure, .cc-founder-grid h2, .cc-founder-grid__intro > *, .cc-founder-grid__tile, .cc-founder-grid__credits'));
    const reveal = element => {
      element.classList.remove('cc-story-reveal--pending');
      observer.unobserve(element);
    };
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, { threshold: 0.03, rootMargin: '0px 0px -24px 0px' });
    targets.forEach(element => {
      const isText = !element.matches('.cc-founder__figure, .cc-founder-grid__tile');
      element.style.setProperty('--cc-reveal-duration', duration + 'ms');
      element.style.setProperty('--cc-reveal-distance', distance + 'px');
      element.classList.add('cc-story-reveal');
      if (isText) element.classList.add('cc-story-reveal--text');
      if (element.getBoundingClientRect().bottom <= 0 || element.contains(document.activeElement)) return;
      element.classList.add('cc-story-reveal--pending');
      observer.observe(element);
    });
  };
  document.addEventListener('focusin', event => {
    const element = event.target.closest('.cc-story-reveal--pending');
    if (element) {
      element.classList.remove('cc-story-reveal--pending');
      if (observer) observer.unobserve(element);
    }
  });
  motion.addEventListener('change', initialize);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-password-welcome"]) return;
  try {
    
  if (!customElements.get('cc-password-field')) {
    customElements.define('cc-password-field', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[name="password"]');
        this.toggle = this.querySelector('[data-password-reveal]');
        if (!this.input || !this.toggle) return;
        this.toggle.checked = false;
        this.input.type = 'password';
        this.querySelector('.cc-welcome__reveal').hidden = false;
        this.onChange = () => { this.input.type = this.toggle.checked ? 'text' : 'password'; };
        this.toggle.addEventListener('change', this.onChange);
      }
      disconnectedCallback() { this.toggle?.removeEventListener('change', this.onChange); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
